import { Skeleton } from '@accure/ui';

/**
 * Loading skeleton for the results bar.
 * Maintains exact layout to prevent cumulative layout shift (CLS).
 */
export function SystemLogsResultsBarLoading() {
  return (
    <div className="flex items-center justify-between p-1">
      <div className="flex items-center gap-3">
        <Skeleton className="h-5 w-24" />
      </div>
      <div className="flex items-center gap-2">
        <Skeleton className="h-8 w-28" />
      </div>
    </div>
  );
}
